import { Utils } from "@framework"
var mouseOffset = require("mouse-event-offset")

export const init = ($ripples) => {
    if (!$ripples) {
        var $ripples = document.querySelectorAll(".-js-ripple:not(.-js-ripple-upgraded)")
    }

    const eventsDown = "ontouchstart" in document.documentElement ? ["touchstart"] : ["mousedown"]
    const eventsUp = "ontouchend" in document.documentElement ? ["touchend"] : ["mouseup", "mouseleave"]
    const eventsEndAnimation = ["animationend", "webkitAnimationEnd", "oanimationend", "MSAnimationEnd"]

    for (const $item of $ripples) {
        // Set animation variables
        var isEnded = false
        var isUP = false

        // Add eventsDown listeners
        Utils.addMultipleEventListeners($item, eventsDown, (e) => {
            isEnded = false
            isUP = false
            const touch = e.type === "touchstart" ? e.changedTouches[0] : e
            const offset = mouseOffset(touch, e.currentTarget)

            $item.style.setProperty("--ripple-x", offset[0] + "px")
            $item.style.setProperty("--ripple-y", offset[1] + "px")

            $item.classList.remove("-is-ripple", "-is-reverse-ripple")
            setTimeout(() => $item.classList.add("-is-ripple"), 1)
        })

        // Add eventsUp listeners
        Utils.addMultipleEventListeners($item, eventsUp, () => {
            isUP = true
            if (isEnded) endRipple()
        })

        // Add animation end listeners
        Utils.addMultipleEventListeners($item, eventsEndAnimation, () => {
            if (!$item.classList.contains("-is-ripple")) return
            isEnded = true
            if (isUP) endRipple()
        })

        const endRipple = () => {
            $item.classList.add("-is-reverse-ripple")
            $item.classList.remove("-is-ripple")
        }

        $item.classList.add("-js-ripple-upgraded")
    }
}
